import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderLeft from "./HeaderLeft";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import DropdownRight from "./DropdownRight";
import GetStorage from "../services/Storage";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import Select from "react-select";

function BankDetails() {
  let user = localStorage.getItem("user");
  user = JSON.parse(user);
  const token = GetStorage.get("xAuthToken");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankOptions, setBankOptions] = useState([]);

  // const bankOptions = [
  //   { value: "chase", label: "Chase" },
  //   { value: "wells-fargo", label: "Wells Fargo" },
  //   { value: "bank-of-america", label: "Bank of America" },
  //   { value: "citibank", label: "Citibank" },
  //   { value: "us-bank", label: "U.S. Bank" },
  // ];

  const initialValues = {
    // achnumber: "",
    routingnumber: "",
    accountnumber: "",
    bankname: "",
  };
  const validationSchema = Yup.object({
    // achnumber: Yup.string().required("required"),
    routingnumber: Yup.string().required("required"),
    accountnumber: Yup.string().required("required"),
    bankname: Yup.object().nullable().required("Bank name is required"), // Validate as an object and nullable
  });

  const fetchBankOptions = async () => {
    try {
      http
      .get(`api/analyst/bank-list?token=${token}`)
      .then((res) => {
        setBankOptions(res.data.data)
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
   }catch(e){
    console.log("e",e);
   }
  }


  useEffect(() => {
    fetchBankOptions();
  }, []);

  const onSubmit = async (values) => {
    setUploadSpin(true);
    http
      .post(`api/analyst/bank?token=${token}`, {
        // achnumber: values.achnumber,
        routingnumber: values.routingnumber,
        accountnumber: values.accountnumber,
        bankname: values.bankname.value,
      })
      .then((res) => {
        console.log("bank response ------->>>>", res.data);
        setUploadSpin(false);

        navigate("/downloadSample");
        // navigate("/almostThere");
      })
      .catch((error) => {
        setUploadSpin(false);

        console.log("error in bank account", error.response.data.errors);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, handleChange, handleBlur, handleSubmit,setFieldValue  }) => (
        <>
          <header>
            <div className="custom_container ">
              <HeaderLeft />
              <div className="user_profile">
                <DropdownRight />
              </div>
            </div>
          </header>
          <section className="otp_verification custom_hight">
            <div className="login_inner ">
              <h1 className="mb_30 main_title ">Welcome {user.data.firstname}!</h1>
              <p className="mb_40 them_para text-center mx-auto text_limit">
                Set up your profile now... Enter your bank details.
              </p>
              <h6 className="sub_title mb_30">Bank Details</h6>
              <div className="container  ">
                <div className="col-lg-8 mx-auto">
                  <form>
                    <div className="row personal_info">

                      {/* <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange("achnumber")}
                            onBlur={handleBlur("achnumber")}
                            value={values.achnumber}
                            placeholder="ACH Number"
                          />{" "}
                        </div>
                        <ErrorMessage name="achnumber" />
                      </div> */}

                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            onChange={handleChange("routingnumber")}
                            onBlur={handleBlur("routingnumber")}
                            value={values.routingnumber}
                            placeholder="Routing Number"
                          />{" "}
                        </div>
                        <ErrorMessage name="routingnumber" />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6">
                        <div className="form-group">
                          <input
                            type="test"
                            className="form-control"
                            onChange={handleChange("accountnumber")}
                            onBlur={handleBlur("accountnumber")}
                            value={values.accountnumber}
                            placeholder="Account Number"
                          />{" "}
                        </div>
                        <ErrorMessage name="accountnumber" />
                      </div>
                      <div className="col-12">
                        {/* <div className="form-group"> */}
                          {/* <input
                            type="test"
                            className="form-control"
                            onChange={handleChange("bankname")}
                            onBlur={handleBlur("bankname")}
                            value={values.bankname}
                            placeholder="Bank Name"
                          />{" "} */}

                          <Select
                            options={bankOptions}
                            onChange={(option) => setFieldValue("bankname", option)}
                            onBlur={handleBlur("bankname")}
                            value={values.bankname}
                            placeholder="Select Bank"
                            isSearchable 
                            styles={{
                              control: (base) => ({
                                ...base,
                                height: '60px',
                                // minHeight: '60px',
                                padding: '5px'
                              })
                            }}
                          />
                          
                        {/* </div> */}
                        <ErrorMessage name="bankname" />
                      </div>
                      <h5 style={{ color: "red" }}>{error}</h5>
                    </div>
                    <div className="btn_wraper">
                      <button
                        type="submit"
                        className="them_btn mt_40 mb_30"
                        onClick={handleSubmit}
                      >
                        {uploadSpin ? (
                          <SpinnerCircular className="button-spin" />
                        ) : (
                          "  Continue"
                        )}
                      </button>
                      {/* <button
                        class="them_btn "
                        onClick={() => navigate("/almostThere")}
                        style={{ marginLeft: 20 }}
                      >
                        Skip
                      </button> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </Formik>
  );
}

export default BankDetails;
